/* file description */
import React from 'react';
import AreaSelectMemo from '../component/AreaSelect';
import AreaSelectRender from '../component/AreaSelect/render';
import { TransformNalmalType2TableColumn } from './type';
import { COLUMN_FROM, VALUE_TYPES } from './consts';
import _ from 'lodash';

export const transformArea2Column: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  // isOpenGroup,
  isMobile,
  moduleInfo,
}) => {
  // console.groupCollapsed(`${field?.label}#${field?.name} transformArea2Column`);
  // console.log('入参field', _.cloneDeep(field));
  // console.log('入参targetColumn', _.cloneDeep(targetColumn));

  targetColumn.valueType = VALUE_TYPES.SELECT;

  targetColumn.renderFormItem = (_a, config, form) => {
    return <AreaSelectMemo field={field} form={form} config={config} columnFrom={config.from} moduleInfo={moduleInfo} isMobile={isMobile} />;
  };

  targetColumn.render = (dom, entity) => {
    const targerValue = entity?.value;
    const { setViewValue } = entity;
    return <AreaSelectRender field={field} targerValue={targerValue} setViewValue={setViewValue} />;
  };

  // console.log('处理后targetColumn', _.cloneDeep(targetColumn));
  // console.groupEnd();

  return targetColumn;
};
